import React from 'react';

export default function HobbiesIcon() {
  return (
    <svg
      className="svg-icon"
      width="42px"
      height="42px"
      viewBox="0 0 42 42"
      role="img"
      aria-labelledby="hobbies-icon-title"
    >
      <title id="hobbies-icon-title">Hobbies Icon</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g fill="#19A6A8" fillRule="nonzero">
          <path d="M37,20 L34,20 L34,12 C34,9.8 32.2,8 30,8 L22,8 L22,5 C22,2.2 19.8,0 17,0 C14.2,0 12,2.2 12,5 L12,8 L4,8 C1.8,8 0,9.8 0,12 L0,19.6 L3,19.6 C6,19.6 8.4,22 8.4,25 C8.4,28 6,30.4 3,30.4 L0,30.4 L0,38 C0,40.2 1.8,42 4,42 L11.6,42 L11.6,39 C11.6,36 14,33.6 17,33.6 C20,33.6 22.4,36 22.4,39 L22.4,42 L30,42 C32.2,42 34,40.2 34,38 L34,30 L37,30 C39.8,30 42,27.8 42,25 C42,22.2 39.8,20 37,20 Z" />
        </g>
      </g>
    </svg>
  );
}
